module.exports = __webpack_public_path__ + "static/media/LPC381V_good.89f921cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/options/LPC381V_good.jpg
// module id = 213
// module chunks = 0